import type { FieldDefinition } from '@/react-query/videa-notes/useVoiceNoteFields';

import { FieldDetailContent } from './FieldDetailContent';
import { FieldDetailEmptyState } from './FieldDetailEmptyState';

export interface FieldDetailPanelProps {
  selectedField: FieldDefinition | null;
  changesSavedAt: number | null;
  suggestedValues: string[];
  defaultDisplayValue: string | null;
  isSetDefaultPending: boolean;
  isSetRequiredPending: boolean;
  onAddValue: () => void;
  onSetDefault: (value: string) => void;
  onSetRequired: (required: boolean) => void;
}

export const FieldDetailPanel = ({
  selectedField,
  changesSavedAt,
  suggestedValues,
  defaultDisplayValue,
  isSetDefaultPending,
  isSetRequiredPending,
  onAddValue,
  onSetDefault,
  onSetRequired,
}: FieldDetailPanelProps) => (
  <div className="vai-w-1/2 vai-min-w-0 vai-flex vai-flex-col vai-rounded-md vai-border vai-border-gray-200 vai-bg-white vai-overflow-hidden vai-p-4">
    {selectedField ? (
      <FieldDetailContent
        field={selectedField}
        changesSavedAt={changesSavedAt}
        suggestedValues={suggestedValues}
        defaultDisplayValue={defaultDisplayValue}
        isSetDefaultPending={isSetDefaultPending}
        isSetRequiredPending={isSetRequiredPending}
        onAddValue={onAddValue}
        onSetDefault={onSetDefault}
        onSetRequired={onSetRequired}
      />
    ) : (
      <FieldDetailEmptyState />
    )}
  </div>
);
